import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import gallery1 from "../assets/gallery1.avif";
import gallery2 from "../assets/gallery2.avif";
import gallery3 from "../assets/gallery3.avif";
import cateringImage from "../assets/catering-image.avif";
import { Helmet } from "react-helmet-async";
import { useUser } from "../context/UserContext";
import { useProfile } from "../context/ProfileContext";
import { useApi } from "../utils/Api";

const HomePage = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isPrevGalleryDisabled, setIsPrevGalleryDisabled] = useState(true);
  const [isNextGalleryDisabled, setIsNextGalleryDisabled] = useState(false);
  const galleryWrapperRef = useRef(null);
  const { openProfile, setActiveTab } = useProfile();
  const wrapperRef = useRef(null);
  const navigate = useNavigate();
  const { apiFetch } = useApi();

  const images = [
    { src: gallery1, alt: "Grilled Fish with Plantain" },
    { src: gallery2, alt: "Assorted Meat Peppersoup" },
    { src: gallery3, alt: "Nigerian Rice and Stew" },
  ];
  const { openLoginModal, user } = useUser();

  // Fetch menu items

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const data = await apiFetch("fetch-random-items");
        setMenuItems(data);
      } catch (error) {
        console.error("Error fetching menu:", error);
      }
    };

    fetchMenuItems();
  }, [apiFetch]);

  const itemsWithViewAll = Array.isArray(menuItems)
    ? [...menuItems, { id: "view-all", viewAll: true }]
    : [{ id: "view-all", viewAll: true }];

  // ===== Scroll-based carousel controls =====
  const scrollAmount = 300; // pixels to scroll per arrow click

  const handleScroll = () => {
    if (!wrapperRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = wrapperRef.current;

    setIsPrevDisabled(scrollLeft <= 0);
    setIsNextDisabled(scrollLeft + clientWidth >= scrollWidth - 5);
  };

  const nextItem = () => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      setTimeout(handleScroll, 400);
    }
  };

  const prevItem = () => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      setTimeout(handleScroll, 400);
    }
  };

  // Disable browser scroll memory
  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);

  // Reset scroll after menu items load
  useEffect(() => {
    if (menuItems.length > 0 && wrapperRef.current) {
      wrapperRef.current.scrollLeft = 0;
      handleScroll();
    }
  }, [menuItems]);

  const handleOrder = () => {
    window.location.href = "/order-online";
  };

  const handleViewMenu = () => {
    navigate("/order-online");
  };

  const galleryScrollAmount = 300;

  const handleGalleryScroll = () => {
    if (!galleryWrapperRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = galleryWrapperRef.current;
    setIsPrevGalleryDisabled(scrollLeft <= 0);
    setIsNextGalleryDisabled(scrollLeft + clientWidth >= scrollWidth - 5);
  };

  const nextGalleryItem = () => {
    if (galleryWrapperRef.current) {
      galleryWrapperRef.current.scrollBy({
        left: galleryScrollAmount,
        behavior: "smooth",
      });
      setTimeout(handleGalleryScroll, 400);
    }
  };

  const prevGalleryItem = () => {
    if (galleryWrapperRef.current) {
      galleryWrapperRef.current.scrollBy({
        left: -galleryScrollAmount,
        behavior: "smooth",
      });
      setTimeout(handleGalleryScroll, 400);
    }
  };

  useEffect(() => {
    handleGalleryScroll();
  }, []);

  return (
    <div className="home-page">
      <Helmet>
        <title>
          LasGidi Restaurant | Authentic Nigerian Cuisine in Manchester
        </title>
        <meta
          name="description"
          content="LasGidi Restaurant offers authentic Nigerian cuisine in Manchester. Explore our menu, book a table, or order online for delicious meals."
        />
        <meta
          name="keywords"
          content="LasGidi Restaurant, Nigerian Cuisine, Manchester Restaurant, Food Delivery, Buffet, Event Halls, Book Table"
        />
        <meta
          property="og:title"
          content="LasGidi Restaurant | Authentic Nigerian Cuisine in Manchester"
        />
        <meta
          property="og:description"
          content="LasGidi Restaurant offers authentic Nigerian cuisine in Manchester. Explore our menu, book a table, or order online for delicious meals."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* ===== HERO SECTION ===== */}
      <section className="hero-section">
        <div className="hero-overlay">
          <div className="order-box-container">
            <div className="order-box">
              {/* <div className="order-toggle-container">
                <div className="order-toggle">
                  <button
                    className={option === "eat-in" ? "active" : ""}
                    onClick={() => setOption("eat-in")}
                  >
                    <i className="fa-solid fa-utensils"></i> Eat-in
                  </button>
                  <button
                    className={option === "pick-up" ? "active" : ""}
                    onClick={() => setOption("pick-up")}
                  >
                    <i className="fa-solid fa-bag-shopping"></i> Pick-up
                  </button>
                  <button
                    className={option === "delivery" ? "active" : ""}
                    onClick={() => setOption("delivery")}
                  >
                    <i className="fa-solid fa-motorcycle"></i> Delivery
                  </button>
                </div>
              </div> */}

              <div className="order-action">
                <button className="order-btn" onClick={handleOrder}>
                  Order Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Only show if user is not logged in */}
      {!user ? (
        <p className="login-text">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            onClick={(e) => {
              e.preventDefault();
              openLoginModal();
            }}
          >
            Log in
          </a>{" "}
          to view your recent orders
        </p>
      ) : (
        <p className="login-text">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            onClick={(e) => {
              e.preventDefault();
              openProfile();
              setActiveTab("orders");
            }}
          >
            View Recent Orders
          </a>
        </p>
      )}

      {/* <section className="cta-section talent-cta">
        <div className="cta-container">
          <div className="cta-overlay">
            <h2>Join Lasgidi Got Talent!</h2>
            <p>
              Do you have a talent you believe deserves a stage? <br></br>
              Lasgidi Restaurant is offering you an opportunity to showcase your
              craft and skill. <b>Send in your application today!</b>
            </p>
            <a href="/lasgidi-got-talent" className="post-review-btn">
              Register Now
            </a>
          </div>
        </div>
      </section> */}

      {/* ===== MENU SECTION ===== */}
      <section className="menu-section">
        <div className="menu-header">
          <h2 className="menu-title">Our menu</h2>
          <div className="menu-controls">
            <button className="view-menu-btn" onClick={handleViewMenu}>
              View Full Menu
            </button>
            <button
              className={`arrow-btn ${isPrevDisabled ? "disabled" : ""}`}
              onClick={prevItem}
              disabled={isPrevDisabled}
            >
              &#10094;
            </button>
            <button
              className={`arrow-btn ${isNextDisabled ? "disabled" : ""}`}
              onClick={nextItem}
              disabled={isNextDisabled}
            >
              &#10095;
            </button>
          </div>
        </div>

        <div
          className="menu-item-wrapper"
          ref={wrapperRef}
          onScroll={handleScroll}
        >
          {itemsWithViewAll.map((item) =>
            item.viewAll ? (
              <div
                className="menu-card view-all-card"
                key="view-all"
                onClick={handleViewMenu}
              >
                <div className="menu-card-content">
                  <h3 className="view-all-text">
                    View Full Menu <span className="arrow">&gt;</span>
                  </h3>
                </div>
              </div>
            ) : (
              <div className="menu-card" key={item.id}>
                <img
                  src={`https://lasgidirestaurant.com/${item.image}`}
                  alt={item.item_name}
                  className="menu-image"
                />
                <div className="menu-card-content">
                  <h3>{item.item_name}</h3>
                  <p className="menu-desc">{item.item_description}</p>
                  <p className="menu-price">
                    <span className="from">FROM</span>
                    <br />£{Number(item.price).toFixed(2)}{" "}
                    {/* <span className="arrow">&nbsp;&gt;</span> */}
                  </p>
                </div>
              </div>
            )
          )}
        </div>
      </section>

      {/* ===== OUR AIM SECTION ===== */}
      <section className="our-aim-section">
        <div className="our-aim-container">
          <img src={cateringImage} alt="catering-img" className="our-aim-img" />
          <div className="our-aim-text">
            <p className="highlight-text">Vision</p>
            <h2>Street food made luxurious</h2>

            <p className="highlight-text">Mission</p>
            <p>
              Honouring our heritage through homemade food, friendly service,
              and a welcoming space that feels like home for every guest.
            </p>

            <p className="highlight-text">Core Value</p>
            <p>
              We are committed to using fresh ingredients and preparing every
              dish with care, consistency, and attention to detail.
            </p>

            <p className="highlight-text">Corporate Philosophy</p>
            <p>
              Our corporate philosophy is built on a commitment to quality,
              integrity, and guest satisfaction. We believe in serving food we
              are proud of, treating our employees with respect, and creating a
              positive dining experience through consistent excellence, while
              listening to our customers, valuing their feedback, and
              continuously improving our standards.
            </p>

            <a href="/order-online">
              <button className="start-order-btn">Start Your Order</button>
            </a>
          </div>
        </div>

        <div className="our-aim-image-container"></div>
      </section>

      {/* ===== GALLERY SECTION ===== */}
      <section className="gallery-section" id="gallery">
        <div className="gallery-header">
          <h2 className="gallery-title">Gallery</h2>
          <div className="gallery-controls">
            <button
              className={`arrow-btn ${isPrevGalleryDisabled ? "disabled" : ""}`}
              onClick={prevGalleryItem}
              disabled={isPrevGalleryDisabled}
            >
              &#10094;
            </button>
            <button
              className={`arrow-btn ${isNextGalleryDisabled ? "disabled" : ""}`}
              onClick={nextGalleryItem}
              disabled={isNextGalleryDisabled}
            >
              &#10095;
            </button>
          </div>
        </div>

        <div
          className="gallery-wrapper"
          ref={galleryWrapperRef}
          onScroll={handleGalleryScroll}
        >
          {images.map((image, index) => (
            <div
              className="gallery-item"
              key={index}
              onClick={() => setSelectedImage(image.src)}
            >
              <img src={image.src} alt={image.alt} />
              <div className="overlay">
                <i className="fa-solid fa-arrow-up-right-from-square arrow-icon"></i>
              </div>
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="lightbox" onClick={() => setSelectedImage(null)}>
            <img src={selectedImage} alt="Full View" className="lightbox-img" />
          </div>
        )}
      </section>

      {/* ===== LOCATIONS SECTION ===== */}
      <section className="locations-section" id="locations">
        <h2 className="locations-title">Locations</h2>

        <div className="map-container">
          <iframe
            title="Lasgidi Restaurant Location"
            src="https://www.google.com/maps?q=34+Wellington+Road,+Manchester,+Eccles+M30+0NP&output=embed"
            allowFullScreen
            loading="lazy"
          ></iframe>

          <div className="location-card">
            <h3 className="location-name">Lasgidi Restaurant</h3>
            <p className="status">
              <span className="status-dot"></span> Open until 9PM
            </p>

            <p className="address">
              34 Wellington Road, Manchester,
              <br />
              Eccles M30 0NP
              <br />
              Phone: <a href="tel:01615660344">0161 566 0344</a>
            </p>

            <div className="hours">
              <p className="hours-title">Delivery Hours</p>
              <p>
                Monday: Closed
                <br />
                Tuesday - Saturday: 1PM - 9PM
                <br />
                Sunday: Closed
              </p>

              <p className="hours-title">Collection Hours</p>
              <p>
                Monday: Closed
                <br />
                Tuesday - Saturday: 1PM - 9PM
                <br />
                Sunday: Closed
              </p>
            </div>

            <div className="buttons">
              <a href="/contact" className="btn-contact">
                Contact Us
              </a>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=34+Wellington+Road,+Manchester,+Eccles+M30+0NP"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-directions"
              >
                Get directions
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
